import { memo, useCallback } from "react"
import styled from "@emotion/styled"
import { useModalSlideUp } from "@/features/useModal"
import ButtonRegular from "@/components/composite/ButtonRegular/main"
import AccountCard from "@/pages/WithdrawAccounts/components/AccountCard"
import { useNavigate } from "react-router-dom"
import { SvgComponent } from "@/components/base/Svg"

const Container = styled.div`
    width: 100%;
    max-height: 90vh;
    min-height: 480rem;
    position: relative;
    padding: 16rem;
    border-top-left-radius: 12rem;
    border-top-right-radius: 12rem;
    background-color: #f2f2f3f2;
`

const ContainerTitle = styled.div`
    font-family: "Gilroy";
    font-weight: 500;
    font-size: 18rem;
    letter-spacing: 0%;
    text-align: center;
    height: 28rem;
    margin-bottom: 16rem;
    color: #131416;
`
const DetailClose = styled(SvgComponent("pages/UserCenterPage/deposit/close.svg"))`
    width: 24rem;
    height: 24rem;
    position: absolute;
    top: 16rem;
    right: 16rem;
`
const ContentWarp = styled.div`
    font-family: "Gilroy";
    font-weight: 500;
    font-size: 18rem;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 8rem;
`

const BottomBlock = styled.div`
    padding: 16rem 0 32rem;
    width: 100%;
`
const SubmitButton = styled(ButtonRegular)`
    width: 100%;
    height: 40rem;
    line-height: 40rem;
    font-weight: 500;
    font-size: 16rem;
    text-align: center;
    box-shadow: none;
`
const SubmitButtonContent = styled.div`
    width: 100%;
    height: 40rem;
    line-height: 40rem;
    font-family: unset;
    font-weight: 500;
    font-size: 16rem;
    color: #ff1f57;
    display: flex;
    align-items: center;
    position: relative;
    img {
        width: 16rem;
        height: 16rem;
        position: absolute;
        left: 16rem;
        top: 50%;
        transform: translateY(-50%);
    }
    span {
        flex: 1;
        text-align: center;
    }
`

const SubmitButtonSvg = styled(SvgComponent("pages/UserCenterPage/withdraw/add_borderless.svg"))`
    width: 16rem;
    height: 16rem;
    position: absolute;
    left: 16rem;
    top: 50%;
    transform: translateY(-50%);
`

export interface SelectWithdrawAccountProps {
    accounts: FinanceAccountApiTypes.Fetcher.Response.Record[]
    channels: FinanceChannelApiTypes.Fetcher.Response.record[]
    selectedAccount?: FinanceAccountApiTypes.Fetcher.Response.Record
    onSelect: (account: FinanceAccountApiTypes.Fetcher.Response.Record) => void
}

function SelectWithdrawAccount(props: SelectWithdrawAccountProps) {
    const { accounts = [], onSelect, selectedAccount, channels = [] } = props

    const navigator = useNavigate()
    const { close: closeModal } = useModalSlideUp("account-page")
    const { close } = useModalSlideUp("search-action")

    const getChannel = useCallback(
        (channelName: string) => {
            return channels?.find((item) => item.name === channelName)
        },
        [channels],
    )

    return (
        <Container>
            <ContainerTitle>Select Withdraw Account</ContainerTitle>
            <DetailClose onClick={closeModal} />
            <ContentWarp>
                {accounts.map((item, index) => (
                    <AccountCard
                        key={item.id}
                        data={item}
                        channel={getChannel(item.channel_name || "")}
                        isSelected={item.id === selectedAccount?.id}
                        onClick={() => {
                            onSelect(item)
                            closeModal()
                        }}
                    />
                ))}
            </ContentWarp>
            {/* <BottomBlock>
                <SubmitButton
                    variant={{
                        type: "solid",
                        backgroundColorLeft: "#fff",
                        backgroundColorRight: "#fff",
                    }}
                >
                    <SubmitButtonContent
                        onClick={() => {
                            navigator(PATHS.WITHDRAW_ACCOUNTS)
                            closeModal()
                            close()
                        }}
                    >
                        <SubmitButtonSvg />
                        <span>Add Withdraw Account</span>
                    </SubmitButtonContent>
                </SubmitButton>
            </BottomBlock> */}
        </Container>
    )
}

export default memo(SelectWithdrawAccount)
